import React from 'react';
import Header from 'header/components/title';

const HeaderTitle = () => (<Header title="Boring Legal Stuff" />);

export default HeaderTitle;
